export enum CustomerBranding {
  BPM = 'big-picture-medical',
  MENICON = 'menicon',
  JNJ = 'jnj'
}

export interface Customer {
  id: string;
  name: string;
  legal_regions: string[];
  platform_name: string;
  branding: CustomerBranding;
}
